import React from 'react'

const InfoCardGrid = ({children}) => {
  return (
    <div className="info-card-grid">{children}</div>
  )
}

export default InfoCardGrid